import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorRegularMedicine from './doctor-regular-medicine';
import DoctorRegularMedicineDetail from './doctor-regular-medicine-detail';
import DoctorRegularMedicineUpdate from './doctor-regular-medicine-update';
import DoctorRegularMedicineDeleteDialog from './doctor-regular-medicine-delete-dialog';

const DoctorRegularMedicineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorRegularMedicine />} />
    <Route path="new" element={<DoctorRegularMedicineUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorRegularMedicineDetail />} />
      <Route path="edit" element={<DoctorRegularMedicineUpdate />} />
      <Route path="delete" element={<DoctorRegularMedicineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorRegularMedicineRoutes;
